import { render, staticRenderFns } from "./CreateNewNotificationDialog.vue?vue&type=template&id=e3318966"
import script from "./CreateNewNotificationDialog.vue?vue&type=script&lang=js"
export * from "./CreateNewNotificationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports